import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from '../layouts/AppHeader';
import { ThemeProvider } from '@mui/material';
import { useAppContext } from '../contexts/AppContext';
import { darkTheme, lightTheme } from '../styles/theme';
import Dialog from '../components/common/Dialog';
import { useDialogContext } from '../contexts/DialogContext';

const Layout = () => {
  const { isDarkMode } = useAppContext();
  const { dialogContent, isOpenDialog, closeDialog } = useDialogContext();

  useEffect(() => {
    const bodyClass = isDarkMode ? 'dark-theme' : 'light-theme';
    document.body.className = bodyClass;
  }, [isDarkMode]);

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <AppHeader />
      <Outlet />
      {dialogContent && (
        <Dialog open={isOpenDialog} onClose={closeDialog} title={dialogContent.title} size={dialogContent.size}>
          {dialogContent.contentComponent}
        </Dialog>
      )}
    </ThemeProvider>
  );
};

export default Layout;
